module.exports = __webpack_public_path__ + "img/HU22310981.222fdc6e.png";